import styled from "styled-components";

export const ImageInputSignUp = styled.span`
    display: flex;
    
`